import { FetchWithAuth } from "digimaker-ui/util";

export function FetchContentFields(contentType: String) {
  return FetchWithAuth("contenttype/get/" + contentType).then((data) => {
    console.log("fetched data:", data);
    let fields = {};

    data.data.fields.forEach((field) => {
      /**
                 [
                 {
                      "children": null,
                      "default_value": null,
                      "description": "",
                      "identifier": "firstname",
                      "is_output": false,
                      "name": "First Name",
                      "parameters": {
                        "max_length": 50
                      },
                      "required": true,
                      "type": "text"
                     },
                 ...
                 ]
                 */
      fields[field.identifier] = field;
    });

    return { definition: data, fields: fields };
  });
}

export function FetchData(url, options?: any) {
  return FetchWithAuth(url, options).then((data) => data.data);
}

export function Operate(url, options?: any) {
  return FetchWithAuth(url, options);
}

export function SubmitData(url, body?: any) {
  return FetchWithAuth(url, {
    method: "POST",
    body: body ? JSON.stringify(body) : "",
  });
}

export function FetchContentData(contentType, contentId) {
  return FetchData("content/get/" + contentType + "/" + contentId);
}

export function DeleteRecord(id) {
  return Operate("icd/finance/delete-record/" + id);
}

export function FetchContentList(contentType, filter?, offset?, limit?) {
  let query = buildFilterQuery(filter);

  if (offset) {
    query.append("offset", offset);
  }

  if (limit || limit === 0) {
    query.append("limit", limit);
  }

  return FetchData("content/list/" + contentType + "?" + query.toString());
}

export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";
export const DATE_SUBMIT_FORMAT = "YYYY-MM-DD";

export function loadFinanceRecordsData(student_id) {
  return FetchData("icd/finance/records/" + student_id);
}

export function loadFinanceData(student_id) {
  return FetchData("icd/finance/get/" + student_id);
}

export function loadSubjectData(subject_id) {
  return FetchData("icd/subject/get/" + subject_id);
}

function buildFilterQuery(filter?) {
  let query = new URLSearchParams();

  if (!filter) {
    return query;
  }

  Object.entries(filter).forEach((f) => {
    let [key, value] = f;

    if (value) {
      query.append(key, "" + value);
    }
  });

  return query;
}

export function loadStudentListData(filter?, offset?, limit?) {
  return FetchContentList("student", filter, offset, limit);
}

export function loadCourseListData(filter?, offset?, limit?) {
  return FetchContentList("course", filter, offset, limit);
}

export function loadSubjectResultData(subject_id: number, filter?) {
  return loadStudentListData(
    { "field.course": filter.course, "field.intake": filter.intake },
    0,
    0,
  )
    .then((student_list) => {
      let list: string[] = [];

      if (!student_list.list) {
        return list;
      }

      student_list.list.forEach((student) => {
        list.push("" + student.id);
      });

      return list;
    })
    .then((student_list) => {
      if (student_list.length == 0) {
        return Promise.resolve([]);
      }

      let query = buildFilterQuery({
        student: student_list.join(","),
        subject: subject_id,
      });

      return FetchData("/icd/subject/result/list?" + query.toString());
    });
}

export function loadFinanceListData(filter?, offset?, limit?) {
  let clean_filter = { ...filter };
  clean_filter.student_no = filter.studentNo;
  delete clean_filter.studentNo;
  let balance = filter.balance;
  delete clean_filter.balance;

  let query = buildFilterQuery(clean_filter);
  if (balance) {
    query.append("balance", balance);
  }

  if (offset) {
    query.append("offset", offset);
  }

  if (limit) {
    query.append("limit", limit);
  }

  return FetchData("icd/finance/list?" + query.toString());
}

export function loadFinanceRecordData(id: number) {
  return FetchData("icd/finance/get-record/" + id);
}

const DataSource = {
  date_display_format: DATE_DISPLAY_FORMAT,
  date_submit_format: DATE_SUBMIT_FORMAT,
  loadFields: (contentType) => FetchContentFields(contentType),
  loadData: (contentType, contentId) =>
    FetchContentData(contentType, contentId),
  loadList: (contentType, filter?, offset?, limit?) =>
    FetchContentList(contentType, filter, offset, limit),
  loadFinanceRecordsData: loadFinanceRecordsData,
  loadFinanceData: loadFinanceData,
  loadFinanceListData: loadFinanceListData,
  submitData: SubmitData,
  loadSubjectData: loadSubjectData,
  loadSubjectResultData: loadSubjectResultData,
  loadCourseListData: loadCourseListData,
  loadFinanceRecordData: loadFinanceRecordData,
};

export default DataSource;
